import {ActionTree} from 'vuex';
import {RootState, ProfileState} from "@/store/types";
import axios from "axios";
import {API_URL} from "@/settings";

const actions: ActionTree<ProfileState, RootState> = {
}

export default actions
